import { create } from "zustand";

type PeriodRangeState = {
  selectedPeriod: string;
  customStart: string;
  customEnd: string;
};

type ViewState = {
  periodRanges: Record<string, PeriodRangeState | undefined>;
  setPeriodRange: (key: string, value: PeriodRangeState) => void;
  values: Record<string, unknown>;
  setValue: <T>(key: string, value: T) => void;
};

// Intentionally in-memory: state survives route changes but resets on reload/logout.
export const useViewStateStore = create<ViewState>((set) => ({
  periodRanges: {},
  setPeriodRange: (key, value) =>
    set((state) => ({
      periodRanges: { ...state.periodRanges, [key]: value },
    })),
  values: {},
  setValue: (key, value) =>
    set((state) => ({ values: { ...state.values, [key]: value } })),
}));
